AFRAME.registerComponent("extra-menu-buttons", {
  schema: {},
  init: function () {
    this.createButtons();
    this.isSectorsPopUpShown = false;
    this.isConfigurePopUpShown = false;

    const self = this;
    this.el.sceneEl.addEventListener("chart-type-changed", function (e) {
      const action = e.detail?.action;
      self._updateSectorsBtnVisibility(action);
    });

    this.el.sceneEl.addEventListener("mmap-mode-changed", function () {
      const chartControlEl = document.querySelector('[chart-type-control]');
      const action = chartControlEl?.getAttribute('chart-type-control')?.selectedPrimeAction;
      if (action === 'mmap') self._updateSectorsBtnVisibility('mmap');
    });

    setTimeout(() => {
      const chartControlEl = document.querySelector('[chart-type-control]');
      if (chartControlEl) {
        const currentAction = chartControlEl.getAttribute('chart-type-control')?.selectedPrimeAction;
        self._updateSectorsBtnVisibility(currentAction);
      }
    }, 200);

    this.onThemeChanged = this.onThemeChanged.bind(this);
    this.el.sceneEl.addEventListener("theme-changed", this.onThemeChanged);

    setTimeout(() => {
      let themeMode = 'Dark';
      if (typeof getCacheItem === 'function') {
        const mainSettings = getCacheItem('mainSettings');
        if (mainSettings && mainSettings.themeMode) {
          themeMode = mainSettings.themeMode;
        }
      }
      this._updateTooltipTheme(themeMode);
    }, 300);

    setTimeout(() => {
      this.addCloseButtonListener();
    }, 100);
  },
  onThemeChanged: function (e) {
    this._updateTooltipTheme(e.detail.themeMode);
  },
  _updateTooltipTheme: function (themeMode) {
    const isLight = themeMode === 'Light';
    const bgColor = isLight ? '#FFFFFF' : '#111111';
    const textColor = isLight ? '#14141C' : '#FFFFFF';

    const bgs = this.el.querySelectorAll('.vr-tooltip-bg');
    bgs.forEach(bg => {
      bg.setAttribute('rounded-box', 'color', bgColor);
    });

    const texts = this.el.querySelectorAll('.vr-tooltip-text');
    texts.forEach(text => {
      text.setAttribute('color', textColor);
    });
  },

  _updateSectorsBtnVisibility: function (action) {
    const sectorsBtn = this.el.querySelector(".vr-sectors-btn");
    if (!sectorsBtn) return;
    if (action === "watchlist-reports") {
      sectorsBtn.setAttribute("visible", false);
      sectorsBtn.removeAttribute("data-raycastable");
    } else if (action === "mmap") {
      sectorsBtn.setAttribute("visible", false);
      sectorsBtn.removeAttribute("data-raycastable");
      if (window.PopupManager) {
        window.PopupManager.close('sectors-control');
      }
    } else {
      sectorsBtn.setAttribute("visible", true);
      sectorsBtn.setAttribute("data-raycastable", "");
    }
  },
  createButtons: function () {
    const buttons = [
      {
        label: "",
        tooltip: "Info",
        image: "/vr-assets/extra-menu-buttons-2/info.png",
        action: toggleInfoPopUp,
        position: "0 0.15 0",
      },
      {
        label: "",
        tooltip: "Configure",
        image: "/vr-assets/extra-menu-buttons-2/configure.png",
        action: toggleConfigurePopUp,
        position: "0 0 0",
      },
      {
        label: "Sectors",
        tooltip: "Sectors",
        image: "/vr-assets/extra-menu-buttons-2/sectors.png",
        action: toggleSectorsPopUp,
        position: "0 -0.15 0",
      },
    ];

    buttons.forEach(({ label, tooltip: tooltipText, image, action, position }) => {
      const btn = document.createElement("a-entity");
      btn.setAttribute("ui-button", {
        label: label || "",
        image: image || "",
        width: 0.12,
        height: 0.12,
        depth: 0.02,
        type: "rounded-box",
        colorScheme: "primary",
        radius: 0.015,
        preferredFontSize: 0.06,
        contentRotation: -135,
        // isAutoRotationContent: true,
      });
      btn.setAttribute("position", position);
      if (label === "Sectors") {
        btn.classList.add("vr-sectors-btn");
      }

      const tooltipContainer = document.createElement("a-entity");
      tooltipContainer.setAttribute("visible", false);
      tooltipContainer.setAttribute("position", "-0.06 0.06 0.15");
      tooltipContainer.setAttribute("rotation", "-45 -90 -90");
      btn.appendChild(tooltipContainer);

      const tooltipBg = document.createElement("a-entity");
      tooltipBg.classList.add('vr-tooltip-bg');
      tooltipBg.setAttribute("rounded-box", {
        width: 0.24, 
        height: 0.08,
        depth: 0.01,
        radius: 0.01,
        color: "#111",
        opacity: 1,
        cornerstyle: 'ext'
      });
      tooltipBg.setAttribute("position", "0 0 0");
      tooltipContainer.appendChild(tooltipBg);

      const tooltip = document.createElement("a-troika-text");
      tooltip.classList.add('vr-tooltip-text');
      tooltip.setAttribute("value", tooltipText);
      tooltip.setAttribute("font-size", 0.035);
      tooltip.setAttribute("align", "center");
      tooltip.setAttribute("position", "0 0 0.006"); 
      tooltip.setAttribute("color", "white");
      tooltip.setAttribute("outline-width", "0.001");
      tooltip.setAttribute("outline-color", "#000");
      tooltipContainer.appendChild(tooltip);

      btn.addEventListener("mouseenter", () => {
        tooltipContainer.setAttribute("visible", true);
      });

      btn.addEventListener("mouseleave", () => {
        tooltipContainer.setAttribute("visible", false);
      });

      btn.addEventListener("click", () => {
        if (action) action.call(this);
      });

      this.el.appendChild(btn);
    });

    function toggleSectorsPopUp() {
      if (window.PopupManager) {
          window.PopupManager.toggle('sectors-control');
          if (window.gtag) gtag('event', `VR_CenterPanel_SectorsClick`);
        return;
      }
      const popUp = document.querySelector("#sectors-control");
      if (!popUp) return;
      this.isSectorsPopUpShown = !this.isSectorsPopUpShown;
      popUp.setAttribute("visible", this.isSectorsPopUpShown);

      const anotherPopUp = document.querySelector("#configure-control");
      if (!anotherPopUp) return;
      this.isConfigurePopUpShown = false;
      anotherPopUp.setAttribute("visible", false);

      if (window.gtag) gtag('event', `VR_CenterPanel_SectorsClick`);
    }
    function toggleConfigurePopUp() {
      if (window.PopupManager) {
          window.PopupManager.toggle('configure-control');
          if (window.gtag) gtag('event', `VR_CenterPanel_ConfigureClick`);
        return;
      }
      const popUp = document.querySelector("#configure-control");
      if (!popUp) return;
      this.isConfigurePopUpShown = !this.isConfigurePopUpShown;
      popUp.setAttribute("visible", this.isConfigurePopUpShown);
      const anotherPopUp = document.querySelector("#sectors-control");
      if (!anotherPopUp) return;
      this.isSectorsPopUpShown = false;
      anotherPopUp.setAttribute("visible", false);

      if (window.gtag) gtag('event', `VR_CenterPanel_ConfigureClick`);
    }

    function toggleInfoPopUp() {
      if (window.PopupManager) {
        window.PopupManager.toggle('info-popup');
        if (window.gtag) gtag('event', `VR_CenterPanel_InfoClick`);
        return;
      }
      const infoComponent = document.querySelector("#info-popup");
      if (!infoComponent) return;
      const isVisible = !!infoComponent.getAttribute("visible");
      if (isVisible) {
          infoComponent.setAttribute("visible", false);
      } else {
          infoComponent.setAttribute("visible", true);

          if (window.gtag) gtag('event', `VR_CenterPanel_InfoClick`);
      }     
    }

    this.addCloseButtonListener = function () {
      const closeButtonSectors = document.querySelector("#close-sectors-popup");
      if (closeButtonSectors) {
        closeButtonSectors.addEventListener("click", () => {
          const popUp = document.querySelector("#sectors-control");
          this.closePopUp(popUp, "isSectorsPopUpShown");
        });
      }
      const closeButtonConfigure = document.querySelector(
        "#close-configure-popup"
      );
      if (closeButtonConfigure) {
        closeButtonConfigure.addEventListener("click", () => {
          const popUp = document.querySelector("#configure-control");
          this.closePopUp(popUp, "isConfigurePopUpShown");
        });
      }
    };

    this.closePopUp = function (popUp, key) {
      if (!popUp) return;

      const id = popUp.getAttribute('id');
      if (window.PopupManager && id) {
          window.PopupManager.close(id);
          this[key] = false;
          return;
      }

      this[key] = false;
      popUp.setAttribute("visible", false);
    };
  },
});
